import { ShieldCheck, Globe2, Server, ArrowRight } from "lucide-react";
import { SectionEyebrow } from "@/components/ui/SectionEyebrow";

const flow = [
  { label: "User Traffic", icon: Globe2 },
  { label: "Security Layer", icon: ShieldCheck },
  { label: "Network", icon: Globe2 },
  { label: "Compute Infrastructure", icon: Server },
  { label: "Application / Business Service", icon: Server },
];

const tags = ["VPS", "Dedicated", "Cloud", "Email", "Monitoring", "Security"];

export function ArchitectureShowcase() {
  return (
    <section className="grid-backdrop border-y border-border bg-navy-secondary/40 py-20">
      <div className="mx-auto max-w-6xl px-5 text-center lg:px-8">
        <SectionEyebrow>How It Fits Together</SectionEyebrow>
        <h2 className="mx-auto mt-5 max-w-2xl font-display text-3xl font-semibold text-text-primary sm:text-4xl">
          A Stronger Foundation for Every Digital Experience
        </h2>

        <div className="mt-14 flex flex-col items-center gap-3 sm:flex-row sm:justify-center sm:gap-2">
          {flow.map((step, i) => (
            <div key={step.label} className="flex items-center gap-2">
              <div className="glass-panel flex flex-col items-center gap-2 rounded-card px-5 py-4">
                <step.icon className="h-5 w-5 text-cyan" strokeWidth={1.6} />
                <span className="max-w-[110px] text-xs font-medium text-text-secondary">
                  {step.label}
                </span>
              </div>
              {i < flow.length - 1 && (
                <ArrowRight className="hidden h-4 w-4 flex-shrink-0 text-text-muted sm:block" />
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-2.5">
          {tags.map((t) => (
            <span
              key={t}
              className="rounded-full border border-border bg-navy-card px-3.5 py-1.5 text-[11px] font-medium text-text-secondary"
            >
              {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
